module.exports = __webpack_public_path__ + "img/engineering__truck.4a707d08.svg";